import { RunningFeatures } from "@sp-crm/core";
import * as React from "react";
import { useFeature } from "store/selectors/hooks";

interface FeatureProps {
    name: RunningFeatures;
    children?: React.ReactNode;
}

export const Feature: React.FC<FeatureProps> = props => {
    const { name, children } = props;

    const enabled = useFeature(name);

    if (enabled && children) {
        return children;
    }
    return null;
};

export const AntiFeature: React.FC<FeatureProps> = props => {
    const { name, children } = props;

    const enabled = useFeature(name);

    if (!enabled && children) {
        return children;
    }
    return null;
};
